// src/hooks/useTTS.ts
import { useState } from "react";
import axios from "axios";

export const useTTS = () => {
  const [loading, setLoading] = useState(false);

  const playAudio = async (text: string) => {
    try {
      setLoading(true);
      // Gọi tới Netlify Function local hoặc production
      const response = await axios.get(
        `https://googlespeak.netlify.app/api/tts?lang=th&text=${encodeURIComponent(
          text
        )}`
      );
      if (response.data && response.data.audioContent) {
        const audio = new Audio(response.data.audioContent);
        await audio.play();
      }
    } catch (error) {
      console.error("Audio playback error:", error);
    } finally {
      setLoading(false);
    }
  };

  return { playAudio, loading };
};
